import { useEffect, useRef, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import Icon from './Icon'

const nav = [['/', '首页'], ['/products', '产品中心'], ['/articles', '技术文章'], ['/cases', '工程案例'], ['/documents', '资料下载'], ['/about', '关于我们']]

export function Header() {
  const [open, setOpen] = useState(false)
  const location = useLocation()
  useEffect(() => setOpen(false), [location])
  return <header className="site-header">
    <div className="nav-shell">
      <Link className="brand" to="/" aria-label="宏图机电首页"><img src="/logo.png" alt="丹佛斯" /><span><b>宏图机电</b><small>工业制冷解决方案</small></span></Link>
      <nav className={open ? 'nav-links open' : 'nav-links'} aria-label="主导航">
        {nav.map(([to, label]) => <NavLink key={to} to={to} end={to === '/'}>{label}</NavLink>)}
        <Link className="nav-contact" to="/#contact">联系我们</Link>
      </nav>
      <button className="menu-button" onClick={() => setOpen(!open)} aria-label={open ? '关闭菜单' : '打开菜单'} aria-expanded={open}><Icon name={open ? 'close' : 'menu'} /></button>
    </div>
  </header>
}

export function Footer() {
  return <footer className="footer" id="contact"><div className="footer-grid container">
    <div><div className="footer-brand"><img src="/logo.png" alt="" /><strong>宏图机电</strong></div><p>自 2009 年成立以来，专注丹佛斯工业制冷产品与解决方案，以可靠产品和专业服务助力客户持续提升系统能效。</p></div>
    <div><h3>快速链接</h3><Link to="/products">产品中心</Link><Link to="/articles">技术文章</Link><Link to="/cases">工程案例</Link><Link to="/faq">常见问题</Link><Link to="/documents">资料下载</Link><Link to="/privacy">隐私政策</Link><Link to="/terms">使用条款</Link></div>
    <div><h3>联系我们</h3><p><Icon name="location" />浙江省温州市龙湾区海滨街道文化路 18 号</p><p><Icon name="phone" /><a href="tel:+8615372829178">+86 15372829178</a></p><p><Icon name="mail" /><a href="mailto:phonetoo@126.com">phonetoo@126.com</a></p></div>
    <div><h3>微信公众号</h3><img className="qr" src="/wechat.jpg" alt="宏图机电微信公众号二维码" /></div>
  </div><div className="copyright">© {new Date().getFullYear()} 温州市宏图机电有限公司 · <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">浙ICP备2025180060号-1</a></div></footer>
}

export default function Layout({ children }) {
  const location = useLocation()
  const lastTrackedPath = useRef(`${location.pathname}${location.search}`)
  useEffect(() => {
    if (location.hash) setTimeout(() => document.getElementById(location.hash.slice(1))?.scrollIntoView({ behavior: 'smooth' }), 50)
    else window.scrollTo({ top: 0 })
  }, [location])
  useEffect(() => {
    const currentPath = `${location.pathname}${location.search}`
    if (currentPath !== lastTrackedPath.current) {
      window._hmt?.push(['_trackPageview', currentPath])
      window.dataLayer?.push({ event: 'page_view', pagePath: currentPath })
      lastTrackedPath.current = currentPath
    }
  }, [location.pathname, location.search])
  useEffect(() => {
    const trackClick = (event) => {
      const link = event.target.closest('a')
      if (!link) return
      const href = link.getAttribute('href') || ''
      const type = href.startsWith('tel:') ? 'phone' : href.startsWith('mailto:') ? 'email' : link.hasAttribute('download') || href.toLowerCase().endsWith('.pdf') ? 'download' : null
      if (!type) return
      window._hmt?.push(['_trackEvent', 'conversion', type, href])
      window.dataLayer?.push({ event: 'conversion', conversionType: type, target: href })
    }
    document.addEventListener('click', trackClick)
    return () => document.removeEventListener('click', trackClick)
  }, [])
  return <><a className="skip-link" href="#main-content">跳到主要内容</a><Header /><main id="main-content">{children}</main><Footer /></>
}
